module.exports = __webpack_public_path__ + "static/media/sdk-logo.019ed2f8.svg";